import React, { useState, useEffect } from 'react';
import './Order.scss';
import { miniApp } from '@telegram-apps/sdk-react';
import { useNavigate, useParams } from "react-router-dom";
import { useMainButton } from '../../hooks/useMainButton';
import { useBackButtonManager } from '../../contexts/BackButtonContext';
import { useCart } from '../../contexts/CartContext';
import OrderStatus from '../../components/ui/OrderStatus';
import api from '../../api';
import LoaderBlock from '../../components/ui/LoaderBlock';
import { useCurrency } from '../../contexts/CurrencyContext';
import ApiImage from '../../components/ApiImage';
import DeliveryIcon from '../../components/ui/DeliveryIcon';
import isEmpty from '../../utils/isEmpty';
import { useToast } from '../../contexts/ToastContext';
import Button from '../../components/ui/Button';
import ProductStatus from '../../components/ui/ProductStatus';
import { formatRub } from "../../utils/formatters";

const Order = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [isLoad, setIsLoad] = useState(true);
  const [isLoadCancel, setIsLoadCancel] = useState(false);
  const navigate = useNavigate();
  const { action, clear } = useBackButtonManager();
  const { setIsEnable } = useCart();
  const { cny, usd, courseDate } = useCurrency();
  const { showConfirm, showToast } = useToast();
  const { disableCancel, setDisableCancel } = useState(false);

  const fetch = async () => {
    try {
      const resp = await api.get(`/api/orders/${id}`);
      setOrder(resp.data);
    } catch(err) {
      console.error(err);
    } finally {
      setIsLoad(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    miniApp.setBackgroundColor('#161618');
    miniApp.setHeaderColor('#161618');
    action(() => {
      if (window.history.length > 2) {
        window.history.back();
      } else {
        navigate("/");
      }
    });
    setIsEnable(false);
    fetch();

    return () => {
      setIsEnable(true);
      clear();
      miniApp.setBackgroundColor('#1D1D20');
      miniApp.setHeaderColor('#1D1D20');
    };
  }, [id]);

  useMainButton();

  if (isLoad) return <LoaderBlock />;

  if (!order) return <div>Заказ не найден</div>;

  const { customer, items, delivery, package: pkg, totals, status } = order;
  const formattedDate = new Date(order.date).toLocaleDateString('ru-RU');

  const confirmCancel = () => {
    setIsLoadCancel(true);
    showConfirm({
      message: "Вы уверены, что хотите отменить заказ?",
      confirmText: "Да",
      cancelText: "Нет",
      onConfirm: () => cancelOrder(),
      onCancel: () => {setIsLoadCancel(false)}
    });
  }

  const cancelOrder = async () => {
    if (isEmpty(id)) return;
    try { 
      
      const orderData = {
        id: id
      };
      const response = await api.post('/api/orders/CancelOrder', orderData);

      if (response.data?.success) {
          showToast(`Заказ успешно отменен`, "info");
          fetch();
          setDisableCancel(true);
          setIsLoadCancel(false);
      } else {
        showToast(`Ошибка при отмене заказа`);
        setIsLoadCancel(false);
      }
    }
    catch (ex) {

    }
  }

  return (
    <div className="order-page page-classes">
      <h2>Заказ от {order.date}</h2>
      <OrderStatus large={true} status={order.status}></OrderStatus>
      {order.status == "in_transit" || order.status == "arrived" || order.status == "completed" ? (
        <div className="delivery-options">
          <div className="delivery-title">Информация по грузу</div>
          <div className="delivery-list">
          <div className="delivery-item">
            <div className="delivery-info">
              <div className="delivery-text">
                <div className="delivery-desc up">Дата отправки</div>
                <div className="delivery-name">{order.dateSend}</div>
              </div>
            </div>
          </div>
          <div className="delivery-item">
            <div className="delivery-info">
              <div className="delivery-text">
                <div className="delivery-desc up">Номер накладной</div>
                <div className="delivery-name">{order.cargo}</div>
              </div>
            </div>
          </div>
        </div>
        </div>
      ):(<></>)}
      <div className="delivery-options">
        <div className="delivery-title">Тип доставки до Москвы</div>
        <div className="delivery-list">
          <div className="delivery-item">
            <div className="delivery-info">
              <div className="delivery-icon">
                <DeliveryIcon icon={delivery.icon}></DeliveryIcon>
              </div>
              <div className="delivery-text">
                <div className="delivery-name">{delivery.name}</div>
                <div className="delivery-desc">до {delivery.day} дней</div>
              </div>
            </div>
            <div className="delivery-price">
              <div className='one-price'>{delivery.cost.toFixed(2)} $</div>
              <div className='weight-price'>{order.weight} кг</div>
              
            </div>
          </div>
        </div>
      </div>
      {pkg ? (
      <div className="delivery-options">
        <div className="delivery-title">Тип упаковки</div>
        <div className="delivery-list">
          <div className="delivery-item">
            <div className="delivery-info">
              <div className="delivery-icon">
                <DeliveryIcon icon={pkg.icon}></DeliveryIcon>
              </div>
              <div className="delivery-text">
                <div className="delivery-name">{pkg.name}</div>
                <div className="delivery-desc"></div>
              </div>
            </div>
            {order.status == "in_transit" || order.status == "arrived" || order.status == "completed" ? (
              <div className="delivery-price">{pkg.cost.toFixed(2)} $</div>
            ):(
              <div className="delivery-price"><span className="non-price">Рассчитывается</span></div>
            )}
          </div>
        </div>
      </div>
      ) : (
        <div className="delivery-options">
          <div className="delivery-title">Тип упаковки</div>
          <div className="delivery-list">
            <div className="delivery-item">
              <div className="delivery-info">
                <div className="delivery-icon">
                </div>
                <div className="delivery-text">
                  <div className="delivery-name">Не определился</div>
                  <div className="delivery-desc"></div>
                </div>
              </div>
              <div className="delivery-price"></div>
            </div>
          </div>
        </div>
      )}
      <div className="delivery-options">
        <div className="delivery-title">Получатель</div>
        <div className="delivery-list">
          <div className="delivery-item">
            <div className="delivery-info">
              <div className="delivery-text">
                <div className="delivery-desc">ФИО</div>
                <div className="delivery-name">{customer.fio}</div>
              </div>
            </div>
          </div>
          <div className="delivery-item">
            <div className="delivery-info">
              <div className="delivery-text">
                <div className="delivery-desc">Город</div>
                <div className="delivery-name">{customer.city}</div>
              </div>
            </div>
          </div>
          <div className="delivery-item">
            <div className="delivery-info">
              <div className="delivery-text">
                <div className="delivery-desc">Телефон</div>
                <div className="delivery-name">{customer.phone}</div>
              </div>
            </div>
          </div>
          <div className="delivery-item">
            <div className="delivery-info">
              <div className="delivery-text">
                <div className="delivery-desc">Комментарий</div>
                <div className="delivery-name">{customer.comment}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='products-box mt-3'>
        <div className="form-title">Ваши товары</div>
        {items.map(item => (
          <div className="cart-item" key={item.id}>
            <div className='cart-main-info'>
              <ApiImage className="item-img" path={item.mainImage} />
              <div className="item-info">
                <div className="item-price">
                  {formatRub((item.cost * cny))} <span className="item-cny">≈ {item.cost.toLocaleString("ru-RU")} ¥</span>
                </div>
                {order?.status?.toLowerCase() !== "completed" && (
                  <div className="item-status">
                    <ProductStatus status={item.status} />
                  </div>
                )}
                <div className="item-name">
                  {item.name}
                </div>
                <div className="item-count">{item.quantity} шт</div>
                
              </div>
            </div>
            {item.description != undefined && item.description != null ? (
                <div className='description-container'>
                  <div className='description'>
                    <span>Комментарий менеджера</span><br/>
                    {item.description}
                  </div>
                </div>
              ) : (<></>)}
          </div>
        ))}
      </div>
      <div className='alert-box'>
        <div className='alert-logo'>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00004 2.66659C5.05452 2.66659 2.66671 5.0544 2.66671 7.99992C2.66671 10.9454 5.05452 13.3333 8.00004 13.3333C10.9456 13.3333 13.3334 10.9454 13.3334 7.99992C13.3334 5.0544 10.9456 2.66659 8.00004 2.66659ZM1.33337 7.99992C1.33337 4.31802 4.31814 1.33325 8.00004 1.33325C11.6819 1.33325 14.6667 4.31802 14.6667 7.99992C14.6667 11.6818 11.6819 14.6666 8.00004 14.6666C4.31814 14.6666 1.33337 11.6818 1.33337 7.99992ZM8.00004 4.66659C8.36823 4.66659 8.66671 4.96506 8.66671 5.33325V8.66659C8.66671 9.03478 8.36823 9.33325 8.00004 9.33325C7.63185 9.33325 7.33337 9.03478 7.33337 8.66659V5.33325C7.33337 4.96506 7.63185 4.66659 8.00004 4.66659ZM7.33337 10.6666C7.33337 10.2984 7.63185 9.99992 8.00004 9.99992H8.00671C8.3749 9.99992 8.67337 10.2984 8.67337 10.6666C8.67337 11.0348 8.3749 11.3333 8.00671 11.3333H8.00004C7.63185 11.3333 7.33337 11.0348 7.33337 10.6666Z" fill="white"/>
          </svg>
        </div>
        <div className='alert-text'>
          <div className='alert-title'>
            Итоговая стоимость не является точной
          </div>
          <div className='alert-description'>
            После оформления заказа с вами свяжется менеджер и уточнит детали по упаковке. Стоимость упаковки оплачивается после получения нами товара на складе в Китае
          </div>
        </div>
      </div>
      <div className='total-box'>
        <table className="price-table">
<tbody>
  <tr>
    <td className="all">Сумма товаров</td>
    <td className="alt">
      {(order.status === "created" || order.status === "waiting") && <>~</>}
      {totals.itemsCny.toLocaleString("ru-RU")} ¥
    </td>
    <td className="amount">
      {(order.status === "created" || order.status === "waiting") && <>~</>}
      {formatRub(totals.itemsRub)}
    </td>
  </tr>

  <tr>
    <td className="sub">Комиссия</td>
    <td className="alt">
      {["created", "waiting"].includes(order.status) && <>~</>}
      {(totals.itemsCny * (order.comission ?? 0) / 100).toLocaleString("ru-RU")} ¥
    </td>
    <td className="amount">
      {["created", "waiting"].includes(order.status) && <>~</>}
      {formatRub(totals.itemsRub * (order.comission ?? 0) / 100)}
    </td>
  </tr>

  <tr>
    <td className="sub">Доставка</td>
    <td className="alt">
      {["created", "waiting", "paid", "assembling"].includes(order.status) && <>~</>}
      {delivery.cost.toLocaleString("ru-RU")} $
    </td>
    <td className="amount">
      {["created", "waiting", "paid", "assembling"].includes(order.status) && <>~</>}
      {formatRub(delivery.cost * usd)}
    </td>
  </tr>

  <tr>
    <td className="sub">Упаковка</td>
    <td className="alt">
      {["created", "waiting", "paid"].includes(order.status) && <>~</>}
      {pkg ? pkg.cost.toLocaleString("ru-RU") : 0} $
    </td>
    <td className="amount">
      {["created", "waiting", "paid"].includes(order.status) && <>~</>}
      {pkg ? formatRub(pkg.cost * usd) : formatRub(0)}
    </td>
  </tr>
</tbody>
        </table>
        <div className='total-price-container'>
          <div className='total-price'>
            <div className='title-price'>Итого</div>
            {order.status != "completed" ? (<div className='actuality-price'>Актуально на {new Date(courseDate).toLocaleDateString('ru-RU')}</div>) : (<></>)}
            
          </div>
          <div className='total-price-amount'> {order.status != "completed" ? (<>~</>) : (<></>)} {formatRub(totals.fullRub)}</div>
        </div>
      </div>
      {order.status == "created" ? (
        <div className='btn-container-fixed'>
          <Button onClick={confirmCancel} disable={disableCancel} load={isLoadCancel} className='btn-secondary large'>Отменить заказ</Button>
        </div>
      ) : (<></>)}
      
    </div>
  );
};

export default Order;
